import { useParams } from "react-router-dom";
import InviteBox from '../components/invite/InviteBox';

export default function Invite() {    
    const params = useParams();

    return (
        <InviteBox invitedFrom={params.from} channelId={params.id}/>
    );
}